var React = require('react');

function PhoneFullsizeShadow (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"274","height":"128","rx":"38","transform":"matrix(1 0 0 -1 0 128)","fill":"url(#paint0_linear_498_36)","fillOpacity":"0.2","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_498_36","x1":"137","y1":"0","x2":"137","y2":"128","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#5966E0","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","key":1})]))]);
}

PhoneFullsizeShadow.defaultProps = {"aria-hidden":"1","width":"274","height":"128","viewBox":"0 0 274 128","fill":"none"};

module.exports = PhoneFullsizeShadow;

PhoneFullsizeShadow.default = PhoneFullsizeShadow;
